import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';

import { AppStyles, AppTheme } from '../styles/AppTheme';
import { CustomMessageDialogStyles } from '../styles/CustomStyles';
import { AppConfig } from '../AppConfig';
import { createStyles, Grid, makeStyles } from '@material-ui/core';
import { UiHelper } from '../common/helpers/UiHelper';

export class MediaScheduleDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  onCloseModal() {
    this.props.onClosed()
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.title}
        fullWidth={false}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({key:'dialogCloseIcon'})}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <div className={css(Styles.inputsHolder)}>
            <div className={css(Styles.inputs)}>
              <p className={css(Styles.fieldLabel)}>Start</p>
              <div className={css(Styles.field)}>{this.props && this.props.scheduleInfo && this.props.scheduleInfo.startStr || ''}</div>
            </div>
            <div className={css(Styles.inputs)}>
              <p className={css(Styles.fieldLabel)}>End</p>
              <div className={css(Styles.field)}>{this.props && this.props.scheduleInfo && this.props.scheduleInfo.endStr || ''}</div>
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

const Styles = StyleSheet.create({
  inputsHolder:{
    minWidth: 500,
    display: 'flex',
    padding: '10px 20px',
    gap: 20
  },
  inputs:{
    flex: 1
  },
  fieldLabel:{
    fontSize: 14,
    color: 'rgb(18, 18, 18)',
    margin: '0px 0px 8px',
  },
  field:{
    padding: '10px 20px',
    flex: '1 1 0%',
    textAlign: 'left',
    fontSize: '16px',
    color: '#000',
    background: 'rgb(217, 217, 217)',
    borderRadius: 8,
    minHeight: 20
  },
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#222222',
    fontSize: 18,
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  modalContent: {
    // maxWidth: 400,
    minWidth: 200,
    padding:10,
    paddingTop: 0,
    paddingBottom: 20,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius
  },
})



// WEBPACK FOOTER //
// ./src/components/MediaScheduleDialog.js